module.exports = __webpack_public_path__ + "static/media/side-hex-contact.571d2903.png";